import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {StudentContestResultData} from 'APIs/letrusAPI/studentContestResult/types';
import styles from './ContestAwardCard.module.scss';

interface ContestAwardCardProps {
  result: StudentContestResultData | null;
}

const medalLabels = {
  gold: 'Ouro',
  silver: 'Prata',
  bronze: 'Bronze',
} as const;

function ContestAwardCard({result}: ContestAwardCardProps): JSX.Element | null {
  if (!result || result.certificate_type === 'participation' || !result.award) {
    return null;
  }

  const isFeaturedComposition = result.award === 'featured_composition';

  const medalLabel =
    !isFeaturedComposition && result.award in medalLabels
      ? medalLabels[result.award as keyof typeof medalLabels]
      : null;

  const title = isFeaturedComposition
    ? 'Parabéns! Sua redação é Destaque!'
    : `Parabéns! Você conquistou a Medalha de ${medalLabel}!`;

  const description = isFeaturedComposition
    ? `Sua redação foi escolhida pelo comitê avaliador entre as duas Redações Destaque do ${result.school_grade}. E tem mais: você também conquistou a Medalha de Ouro!`
    : 'Seu desempenho na Linguagem em Ação — Olimpíada Nacional de Redação da Letrus garantiu a você esse reconhecimento.';

  const supportingText = isFeaturedComposition
    ? 'Você receberá: troféu + medalha + certificado impresso + kit especial da Olimpíada. Aguarde o contato da Letrus com as orientações para o envio da sua premiação.'
    : 'Sua medalha será enviada para a sua escola.';

  return (
    <section className={styles.card} aria-labelledby="award-title">
      <span className={styles.kicker}>Premiação</span>

      <div className={styles.content}>
        <div className={styles.titleRow}>
          <FontAwesomeIcon
            icon={isFeaturedComposition ? ['fad', 'trophy'] : ['fad', 'medal']}
            className={styles.icon}
          />
          <h2 id="award-title" className={styles.title}>
            {title}
          </h2>
        </div>

        <p className={styles.description}>{description}</p>
        <p className={styles.supportingText}>{supportingText}</p>
      </div>
    </section>
  );
}

export default ContestAwardCard;
